import { createGlobalStyle } from 'styled-components';
import { theme } from '../../theme';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Playfair+Display:wght@400;700&display=swap');
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: ${theme.fonts.body};
    font-size: 16px;
    line-height: 1.6;
    color: ${theme.colors.textLight};
    background-color: ${theme.colors.dark};
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    margin-bottom: 1rem;
    color: ${theme.colors.accent};
  }
  
  a {
    text-decoration: none;
    color: ${theme.colors.accent};
  }
  
  img {
    max-width: 100%;
  }
`;

export default GlobalStyles;